<template>
  <md-toolbar md-elevation="0" class="md-transparent">
    <!--        <link rel="stylesheet"-->
    <!--              href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>-->
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <!-- <h3 class="md-title">{{ $route.name }}</h3> -->
        <bread-crumbs class="md-title" :links="links">{{
            breadCrumbs
          }}
        </bread-crumbs>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
            class="md-just-icon md-simple md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>


        <template>
          {{ time | formatTime}}
        </template>

        <!-- Showing notifications -->
        <top-bar-notifications></top-bar-notifications>

        <md-menu md-size="auto" :md-offset-x="-200" :md-offset-y="0">
          <md-button
              md-menu-trigger
              class="md-icon-button md-dense md-transparent"
          >
            <md-icon>person</md-icon>
          </md-button>
          <md-menu-content class="menu-content-profile md-size-100 text-center">
            <md-menu-item class="flex-header" data-background-color="purple">
              <div class="avatar-icon">
                <md-avatar class="md-avatar-icon md-primary">{{ (username || '').charAt(0) }} </md-avatar>
              </div>
              <div class="user-info">
                <span class="md-title">{{ username || '' }}</span>
                <md-menu-item md-menu-trigger class="login-attempt-menu-item" @click="showLoginAttempts = true">
                  <span class="md-headline login-attempts"> Last Login: {{ lastLogin | dateTime }}</span>
                </md-menu-item>
              </div>
            </md-menu-item>

            <md-divider></md-divider>
              <md-menu-item md-menu-trigger class="md-primary" @click="showChangePasswordDialog=true">
                <i class="fas fa-key fa-fw fa-sm" aria-hidden="true"></i> Change Password
              </md-menu-item>
            <md-divider></md-divider>
              <md-menu-item md-menu-trigger class="md-dense md-primary" @click="logOut">
                <i class="fas fa-sign-out-alt fa-fw"></i> sign out
              </md-menu-item>
          </md-menu-content>
        </md-menu>
      </div>
      <change-password
        :show="showChangePasswordDialog"
        @close="showChangePasswordDialog = false"
        @changed="passwordChanged"
      ></change-password>
      <login-attempts :show="showLoginAttempts" @close="showLoginAttempts = false"></login-attempts>
    </div>
  </md-toolbar>
</template>

<script>
// Import OIDC services
import Mgr from "../../services/OIDCManager";
import {BreadCrumbs} from "@/components";
import SAMAN_CONFIG from "../../global-config";
import moment from "moment";
import ChangePassword from "@/components/ChangePassword";
import TopBarNotifications from "../../components/TopBarNotifications";
import snakeCaseObjectKeysToCamelCase from "../../utils/snakeCaseObjectKeysToCamelCase";
import LoginAttempts from "@/components/LoginAttempts";
import { forceLogout, refreshAccessToken } from "../../utils/authStorageManager";

export default {
  props: {
    links: Array,
  },
  components: {
    LoginAttempts,
    BreadCrumbs,
    ChangePassword,
    TopBarNotifications,
  },
  data() {
    return {
      username: "",
      time: '',
      showChangePasswordDialog: false,
      showLoginAttempts: false,
      lastLogin: "",
      breadCrumbs: [],
    };
  },
  filters: {
    formatTime(value) {
      if (!value) return '';
      return moment(value).format('MMMM Do YYYY, h:mm:ss a'); // April 3rd 2021, 5:23:32 am
    },
    dateTime(value) {
      if (!value) return "";
      return moment(value).format("DD/MM/YYYY, h:mm a"); // 27/03/2022, 12:03 pm
    },
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    async logOut() {
      if (SAMAN_CONFIG.enableSSO) {
        let mgr = new Mgr();
        mgr.signOut();
      } else {
        const response = await this.$api.logout({
        axiosConfig: { withCredentials: true }
      });

        if (response.status === 200) {
          forceLogout();
        } else {
          this.$notify({
            message: "Logout was not successful!",
            icon: "error",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
    getServerTime: async function () {
      try {
        let url =
          this.$store.state.server_address + "api/v1/dashboard/server-time/";

        let headers = {
          "Content-Type": "application/json",
          Authorization: this.$store.getters.getAccessToken
        };
        let response = await fetch(url, {
          method: "GET",
          headers: headers
        });
        let jsonResponse = await response.json();
        this.time = jsonResponse.response.server_time * 1000
        setInterval(this.timer, 1000)
      } catch (error) {
        console.log(error);
      }
    },
    timer(){
     this.time += 1000;
    },
    async getLastLogin() {
      const response = await this.$api.whoAmI();
      this.lastLogin = snakeCaseObjectKeysToCamelCase(response.parsedData).lastLogin;
    },
    async passwordChanged() {
      this.showChangePasswordDialog = false;
      this.$notify({
        message: "Password successfully changed.",
        icon: "info",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });

      try {
        await refreshAccessToken();
      } catch (err) {
        forceLogout();
      }
    },
  },
  mounted() {
    this.getServerTime();
    this.getLastLogin();
    if (SAMAN_CONFIG.enableSSO) {
      let mgr = new Mgr();
      mgr.getUser().then(user => {
        this.username = user.profile.nickname;
      });
    } else {
      this.username = window.localStorage.getItem("username");
    }
  }
};
</script>

<style lang="scss">
.flex-header {
  display: flex;
  justify-content: space-between;
}

.inline-table {
  display: inline-table;
}

.menu-content-profile {
  width: 300px;
}

.menu-content-profile .md-menu-content-container {
  .md-list.md-theme-default {
    display: inline-flex;
  }
}

.menu-content-profile .md-menu-content-container.md-scrollbar.md-theme-default {
  display: inline-grid;
}

.login-attempts {
  cursor: pointer;
  max-width: 100%;
  font-size: 12px;
  padding: 0;
}

.login-attempts.md-headline {
  font-size: 12px;
}

.avatar-icon {
  margin: 4px 0 auto;
}

.user-info {
  text-align: left;
  width: 75%;
}

.login-attempt-menu-item.md-list-item {
  font-size: 12px;
  margin-left: 0;

  .md-list-item-content.md-ripple {
    .md-ripple-wave {
      display: none;
    }
    span {
      height: auto;
    }
    min-height: auto;
  }

  button:hover {
    background: none !important;
  }
}

.md-menu-content-container .md-list{
  font-family: 'rajdhani' !important;
}
</style>
